import {ComboboxProps, DialogDismiss, useComboboxContext} from '@ariakit/react'
import {forwardRef, useCallback, RefObject, useState} from 'react'
import {StyledCommandMenuCombobox, StyledCommandMenuDismissButton, StyledCommandMenuInputWrapper} from './style'
import {useTranslation} from '@/translations/i18n'
import {Button} from '@/components/ui/button/Button'
import {XCloseIcon} from '@/components/ui/icon/Icon'

export const CommandMenuInput = forwardRef<
    HTMLInputElement,
    ComboboxProps & {hasSearch: boolean; resetSearch: (ref: RefObject<HTMLInputElement>) => void}
>(function CommandMenuInput({hasSearch, resetSearch, ...props}, ref) {
    const {t} = useTranslation()
    const [search, setSearch] = useState('')
    const combobox = useComboboxContext()

    const handleClearSearch = useCallback(() => {
        // Clear the combobox value using Ariakit's setValue
        if (combobox) {
            combobox.setValue('')
            setSearch('')
        }

        // Call the resetSearch function from parent
        if (ref && typeof ref == 'object' && ref.current) {
            resetSearch(ref)
        }
    }, [combobox, resetSearch, ref])

    return (
        <StyledCommandMenuInputWrapper gap={2} align="center">
            <StyledCommandMenuCombobox
                placeholder={t('global_search:search_patient_placeholder')}
                autoSelect="always"
                ref={ref}
                value={search}
                onChange={e => setSearch(e.target.value)}
                {...props}
            />
            {hasSearch ? (
                <Button variant="ghost" shape="square" onClick={handleClearSearch}>
                    <XCloseIcon />
                </Button>
            ) : (
                <DialogDismiss
                    render={<StyledCommandMenuDismissButton variant="secondary">Esc</StyledCommandMenuDismissButton>}
                />
            )}
        </StyledCommandMenuInputWrapper>
    )
})
